import { motion, useReducedMotion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export const fadeUp = { hidden: { opacity: 0, y: 22 }, show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.65, delay: i * 0.07, ease: [0.22, 1, 0.36, 1] } }) };
export const Reveal = ({ children, i = 0, className = "", ...props }) => {
  const reduced = useReducedMotion();
  return <motion.div variants={fadeUp} custom={i} initial={reduced ? false : "hidden"} whileInView="show" viewport={{ once: true, amount: 0.08 }} className={className} {...props}>{children}</motion.div>;
};
export const Label = ({ children, ...props }) => <span className="mk-eyebrow" {...props}>{children}</span>;

export const PageHero = ({ eyebrow, title, accent, subtitle, children }) => (
  <section className="mk-page-hero" data-testid="marketing-page-hero">
    <img src="/marketing/architecture.webp" alt="" className="mk-hero-backdrop" width="1600" height="1000" />
    <div className="mk-container"><Reveal><Label>{eyebrow}</Label></Reveal>
      <Reveal i={1}><h1 className="mk-display" data-testid="marketing-page-title">{title}{accent && <> <em>{accent}</em></>}</h1></Reveal>
      {subtitle && <Reveal i={2}><p className="mk-lead" data-testid="marketing-page-description">{subtitle}</p></Reveal>}
      {children && <Reveal i={3}><div className="mk-hero-actions">{children}</div></Reveal>}
    </div><span className="mk-hero-rule" aria-hidden="true" />
  </section>
);

export const SectionHeading = ({ eyebrow, title, description, light = false, id = "section" }) => (
  <div className={`mk-section-heading ${light ? "mk-heading-light" : ""}`}>
    <p className="mk-eyebrow" data-testid={`${id}-eyebrow`}>{eyebrow}</p><h2 className="mk-statement" data-testid={`${id}-heading`}>{title}</h2>
    {description && <p className="mk-lead" data-testid={`${id}-description`}>{description}</p>}
  </div>
);

export const ClosingCTA = ({ title = "Send your next investor update from TenX.", description = "Set up your workspace, add investors, and publish your first update today. Free Starter plan, no card required.", id = "closing", to = "/register", label = "Start free" }) => (
  <section className="mk-closing" data-testid={`${id}-cta-section`}><div className="mk-container"><Reveal>
    <p className="mk-eyebrow">The founder-investor operating system</p><h2 className="mk-statement" data-testid={`${id}-cta-title`}>{title}</h2><p className="mk-lead">{description}</p>
    <div className="mk-hero-actions"><Button asChild className="mk-button mk-button-orange" data-testid={`${id}-start`}><Link to={to}>{label}<ArrowUpRight size={18} /></Link></Button><Link className="mk-text-link" to="/pricing" data-testid={`${id}-pricing`}>Compare plans <ArrowUpRight size={17} /></Link></div>
  </Reveal></div></section>
);